const VOICE_ROUTE_LABEL = {
  SETUP: 'Setup voice app',
  GENERAL_SETTINGS: 'General settings',
  PARTICIPANTS: 'Participants',
};

const VOICE_INBOX_STATUS = {
  ACTIVE: 1,
  DISABLED: -2,
};

const VOICE_INBOX_POST_MESSAGE = {
  CREATE: 'VoiceCreate',
  TOGGLE: 'ToggleVoiceInbox',
}

export {
  VOICE_ROUTE_LABEL,
  VOICE_INBOX_STATUS,
  VOICE_INBOX_POST_MESSAGE,
}
